<template>
  <div>
    <h1 class="mb-0">Registrar Empresa</h1>
    <p>Por favor indica los datos básicos para el administrador y la empresa. (Todos los campos son obligatorios)</p>
    <sign-up1-form formType="firebase"></sign-up1-form>
  </div>
</template>
<script>

import SignUp1Form from './Forms/SignUp1Form'
import auth0 from 'auth0-js'
import constant from '../../../config/constant'

export default {
  name: 'SignUp1',
  components: { SignUp1Form },
  data: () => {
    return {
      
    }
  },
  methods: {
    loginOAuth0 () {
      new auth0.WebAuth(constant.auth0Config).authorize()
    }
  }
}
</script>
